import type { IconSvgObject } from './types';

const ArrowUpFromLineIcon: IconSvgObject = [
  ["path", { d: "M7 3.5V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 3.5V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 21H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M4 5.99998C4 5.99998 6.20947 3.00001 7.00002 3C7.79058 2.99999 10 6 10 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M14 5.99998C14 5.99998 16.2095 3.00001 17 3C17.7906 2.99999 20 6 20 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default ArrowUpFromLineIcon;
